module.exports = __webpack_public_path__ + "static/img/73.58e68a15.jpg";